<template>
  <div class="settings">
    <h3>
      Datos generales
    </h3>
    <div class="settings__form">
      <vs-input name="firstname"
                :danger="this.errors.has('firstname')"
                :danger-text="this.errors.first('firstname')"
                :disabled="!canUpdateUser"
                size="large"
                label-placeholder="Nombre"
                v-model="user.firstname">
      </vs-input>
      <vs-input name="lastname"
                v-validate="'required'"
                :danger="this.errors.has('lastname')"
                :danger-text="this.errors.first('lastname')"
                :disabled="!canUpdateUser"
                size="large"
                label-placeholder="Apellido"
                v-model="user.lastname">
      </vs-input>
      <vs-input name="cuil"
                disabled
                :danger="this.errors.has('cuil')"
                :danger-text="this.errors.first('cuil')"
                size="large"
                label-placeholder="CUIL"
                v-model="user.cuil">
      </vs-input>
      <vs-input name="dni"
                disabled
                :danger="this.errors.has('dni')"
                :danger-text="this.errors.first('dni')"
                size="large"
                label-placeholder="DNI"
                v-model="user.dni">
      </vs-input>
      <vs-input name="email"
                :danger="this.errors.has('email')"
                :danger-text="this.errors.first('email')"
                :disabled="!canUpdateUser"
                size="large"
                v-validate="'email'"
                label-placeholder="Email"
                v-model="user.email">
      </vs-input>
      <vs-input name="phone"
                disabled
                :danger="this.errors.has('phone')"
                :danger-text="this.errors.first('phone')"
                size="large"
                label-placeholder="Teléfono"
                v-model="user.phone">
      </vs-input>
    </div>

    <h3>Contraseña</h3>
    <div class="settings__form">
      <vs-input name="oldPassword"
                type="password"
                v-validate="'min:8|validateOnDB:user,password'"
                :danger="this.errors.has('oldPassword')"
                :danger-text="this.errors.first('oldPassword')"
                size="large"
                label-placeholder="Contraseña actual"
                v-model="password.actualPassword">
      </vs-input>
      <div class="input-btn tip">
        <vs-input name="password"
                  data-test="input-password"
                  v-validate="'min:8|validateOnDB:user,password'"
                  :danger="this.errors.has('password')"
                  :danger-text="this.errors.first('password')"
                  type="password"
                  size="large"
                  label-placeholder="Nueva contraseña"
                  v-model="password.password">
        </vs-input>
        <vs-input name="newPassword"
                  data-test="input-password"
                  v-validate="'min:8'"
                  :danger="this.errors.has('newPassword')"
                  :danger-text="this.errors.first('newPassword')"
                  type="password"
                  size="large"
                  label-placeholder="Repita nueva contraseña"
                  v-model="password.passwordConfirmation">
        </vs-input>
        <span class="infotip top">
          <button class="infotip__host" aria-controls="infotip-overlay" aria-expanded="true" aria-label="Help" type="button">
            <vs-icon icon="help_outline"/>
          </button>
          <span class="infotip__live-region" aria-live="off">
            <div class="infotip__overlay" id="infotip-overlay">
              <div class="infotip__overlay-heading">Su contraseña debe:</div>
              <ul class="infotip__overlay-list">
                <li>Contener caracteres tanto en mayúsculas como en minúsculas (Ej. a-z, A-Z).</li>
                <li>Tener letras, dígitos y caracteres de puntuación (Ej: 0-9, !@#$%^&*()_+|~-=`{}[]:";'<>?,./ ).</li>
                <li>La contraseña debe respetar los lineamientos de contraseña segura.</li>
              </ul>
            </div>
          </span>
        </span>
      </div>
    </div>
    <div v-if="error" class="o-alert o-alert--danger">{{ error }}</div>
    <div class="settings__footer">
      <vs-button color="success" type="filled" @click="updateUser(user)">Actualizar</vs-button>
    </div>
  </div>
</template>



<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapState } from 'vuex'

const updateUser = gql`
  mutation updateUser($userId: Int!, $lastname: String, $firstname: String, $email: String, $password: PasswordInput, $phone: String, $establishmentRoles: [EstablishmentRoleInput!], $currentUserToken: String!){
    updateUser(userId: $userId, lastname: $lastname, firstname: $firstname, email: $email, password: $password, phone: $phone, establishmentRoles: $establishmentRoles, currentUserToken: $currentUserToken) {
      code
      success
      message
    }
  }
`

export default {
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    }),
    isRequired() {
      if (this.password.actualPassword || this.password.password || this.password.passwordConfirmation) {
        return true
      } else {
        return false
      }
    },
    canUpdateUser () {
      if (this.currentUser) {
        if (this.currentUser.roles.filter(role => role.resourceType == 'Establishment').map(e => e.name).includes('admin')) {
          return true
        }
      }
      return false
    }
  },
  data() {
    return {
      user: {},
      password: {},
      error: ''
    }
  },
  watch: {
    currentUser() {
      this.user = this.currentUser
    }
  },
  beforeMount() {
    this.user = {...this.currentUser}
  },
  methods: {
    updateUser(user) {
      if (this.currentUser.firstname == user.firstname && this.currentUser.email == user.email && this.currentUser.lastname == user.lastname && !this.password.actualPassword ) {
        this.error = 'Debe modificar al menos un campo'
      } else {
        var password = {}
        this.$validator.validate().then(res => {
          if (res) {
            if (this.password.actualPassword || this.password.password || this.password.passwordConfirmation) {
              password = {
                password: {
                  actualPassword: this.password.actualPassword,
                  password: this.password.password,
                  passwordConfirmation: this.password.passwordConfirmation
                } 
              }
            }
            axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
              query: print(updateUser),
              variables: Object.assign({
                userId: user.id,
                lastname: user.lastname,
                firstname: user.firstname, 
                email: user.email, 
                currentUserToken: localStorage.getItem('USER_TOKEN')
              }, password)
            }).then(res => {
              if(res.data.data.updateUser.success) {
                this.$vs.notify({
                    title: 'Usuario actualizado',
                    time: 8000,
                    text: 'El usuario fue actualizado con exito',
                    color: '#50b83d',
                    position: 'top-right',
                    icon: 'check_circle'
                })
              } else {
                this.$vs.notify({
                  title: 'Ha ocurrido un error',
                  time: 3000,
                  text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              }
            }).catch(err => {
              this.$vs.notify({
                  title: 'Ha ocurrido un error',
                  time: 3000,
                  text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              console.log(err)
            }).finally( () => {
                this.password.actualPassword = ''
                this.password.password = ''
                this.password.passwordConfirmation = ''
                this.error = ''
            })
          }
        })
      }
    }
  }
}
</script>
